import PropTypes from 'prop-types';
import {
  ModalView as ChangePasswordView,
} from '@codev/change-password-experience';
import {
  Form,
  SubmitButton,
} from '@codev/helix-react';
import React from 'react';
import {
  Col,
  Row,
  ButtonToolbar,
  Button,
} from 'react-bootstrap';
import createLoginLink from './createLoginLink.js';

const NewPasswordForm = ({
  isFirstTimeAdmin,
  onSubmit,
  onChange,
  value,
}) => (
  <Form
    style={{marginLeft:'20px', marginTop: '8px', marginRight: '20px', width: '100%'}}
    onSubmit={onSubmit}
  >
    <ChangePasswordView
      newPassword={value}
      onChangeNewPassword={onChange}
    />

    <div
      style={{border:'1px solid rgb(224, 224, 224)', margin: '16px 0'}}
    />

    <Row
      style={{marginBottom: '20px'}}
    >
      <Col
        xs={12}
        style={{display:'flex'}}
      >
        <ButtonToolbar
          style={{marginLeft:'auto', marginRight: '20px'}}
        >
          {
            !isFirstTimeAdmin &&
            <Button
              href={createLoginLink()}
              bsStyle="default"
            >
              Back to Login Page
            </Button>
          }
          <SubmitButton
            bsStyle="primary"
          >
            { isFirstTimeAdmin ? 'Set Password' : 'Reset Password' }
          </SubmitButton>
        </ButtonToolbar>
      </Col>
    </Row>
  </Form>
);

NewPasswordForm.propTypes = {
  isFirstTimeAdmin: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default NewPasswordForm;
